import { useEffect, useState } from "react";
import { http, resolveImage } from "@/lib/api";

const PAGE_DEFAULTS = {
  home: { title: "The Simple Truths Club — Art with a story." },
  "mirror-conversations": { title: "Mirror Conversations™ — Simple Truths Club" },
  "empty-chair": { title: "The Empty Chair — Simple Truths Club" },
  "breathing-room": { title: "The Breathing Room — Simple Truths Club" },
  "reflection-library": { title: "Reflection Library™ — Simple Truths Club" },
  workshops: { title: "Workshops — Simple Truths Club" },
  booking: { title: "Book a Session — Simple Truths Club" },
};

export function useSEO(pageKey) {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    if (!pageKey) return;
    http.get(`/seo/${pageKey}`).then((r) => setSeo(r.data)).catch(() => {});
  }, [pageKey]);

  useEffect(() => {
    if (!seo) return;
    const defaults = PAGE_DEFAULTS[pageKey] || {};
    const title = seo.title || defaults.title;
    if (title) document.title = title;

    const setMeta = (name, content, property = false) => {
      if (!content) return;
      const attr = property ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };

    setMeta("description", seo.meta_description);
    setMeta("keywords", seo.keywords);

    const ogTitle = seo.og_title || seo.title || defaults.title;
    const ogDesc = seo.og_description || seo.meta_description;
    const ogImage = seo.og_image ? resolveImage(seo.og_image) : "";

    setMeta("og:title", ogTitle, true);
    setMeta("og:description", ogDesc, true);
    if (ogImage) setMeta("og:image", ogImage, true);
    setMeta("og:type", "website", true);

    setMeta("twitter:card", ogImage ? "summary_large_image" : "summary", true);
    setMeta("twitter:title", ogTitle, true);
    setMeta("twitter:description", ogDesc, true);
    if (ogImage) setMeta("twitter:image", ogImage, true);

    return () => {
      document.title = "Simple Truths Club";
    };
  }, [seo, pageKey]);

  return seo;
}
